/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Side Nav Issues Icon component.
 */
export const SideNavIssuesIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19117)'>
        <path d='M17.2557 17.8281V11.8601C17.2557 9.15661 14.8405 6.96484 11.8614 6.96484C8.88237 6.96484 6.4668 9.15661 6.4668 11.8601V17.8281' stroke={iconColor} strokeWidth='1.5' />
        <rect x='4.43896' y='18.0576' width='14.8443' height='3.36223' rx='1.131' stroke={iconColor} strokeWidth='1.5' />
        <path d='M3.44996 11.6055H1' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <path d='M5.73119 6.29461L3.99902 4.72266' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <path d='M22.1702 11.6055H19.7202' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <path d='M11.5845 2V4.22336' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <path d='M16.9961 6.29461L18.7283 4.72266' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      </g>
      <defs>
        <clipPath id='clip0_14304_19117'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SideNavIssuesIcon;
